
import { buryPointData } from '../views/b2b/api/buriedPoint'

export default class Click {
    add (entry) {
        const tp = entry.el.attributes['track-params'].value
        entry.el.addEventListener('click', function () {
            const data = [JSON.parse(tp)]
            buryPointData({ track_data_array: data })
        })
    }
}